<script>
import Button from "@/components/atoms/button";
import ButtonGroup from "@/components/molecules/button-group";
import Card from "@/components/molecules/card";
import ButtonIcon from "@/components/molecules/button-icon";
import FormRadio from "@/components/molecules/form-radio";
import StickyFooter from "@/components/molecules/sticky-footer";
import FormFieldset from "@/components/molecules/form-fieldset";
import FormLegend from "@/components/molecules/form-fieldset/legend";
import Popin from "@/components/molecules/popin";
import Divider from "@/components/atoms/divider";
import AdresseLadRecap from "@/components/organisms/adresse-lad-recap-livreur";
import {
  addressLadSelectorEmits,
  addressLadSelectorProps,
  useAdressLadSelector
} from "./mixin";

export default {
  name: "ShippingMethodLad",
  components: {
    Button,
    Card,
    ButtonIcon,
    FormRadio,
    StickyFooter,
    FormFieldset,
    FormLegend,
    Popin,
    ButtonGroup,
    Divider,
    AdresseLadRecap
  },
  props: {
    ...addressLadSelectorProps()
  },
  emits: {
    ...addressLadSelectorEmits()
  },
  setup(props, context) {
    const {
      selectedAdressId,
      defaultAddress,
      otherAddresses,
      unavalaibleAddresses,
      adressSelected,
      resetAdress
    } = useAdressLadSelector(props, context);

    return {
      selectedAdressId,
      defaultAddress,
      otherAddresses,
      unavalaibleAddresses,
      adressSelected,
      resetAdress
    };
  },
  methods: {
    addAddresse() {
      navigateToInternal({
        path: "/commander/adresse-livraison",
        query: this.checkEligibilite === false ? { "check-eligibilite": 0 } : {}
      });
    },
    editAddresse(id) {
      navigateToInternal({
        path: `/commander/adresse-livraison/${id}`,
        query: this.checkEligibilite === false ? { "check-eligibilite": 0 } : {}
      });
    }
  }
};
</script>

<template>
  <div>
    <template v-if="adressesLad.length === 0">
      <div class="u-text-center u-pb-xlg u-pr-lg u-pl-lg">
        <p class="u-mb-lg u-font-secondary u-font-700 u-font-20">
          Vous n'avez pas encore enregistré d'adresse de livraison
        </p>
        <Button
          variant="secondary"
          radius="full"
          size="md"
          :to="`adresse-livraison${checkEligibilite ? '' : '?check-eligibilite=false' }`"
        >
          Je saisis mon adresse de livraison
        </Button>
      </div>
    </template>

    <template v-if="adressesLad.length > 0 && !selectedAddress">
      <div class="u-pt-sm u-pl-md u-pr-md u-pb-md">
        <p class="u-mb-md">
          Merci de choisir votre adresse de livraison
        </p>
        <form>
          <FormFieldset v-if="defaultAddress">
            <FormLegend class="u-mb-sm">
              Votre adresse habituelle
            </FormLegend>
            <FormRadio
              v-model="selectedAdressId"
              name="address"
              block
              class="u-mb-md"
              :value="defaultAddress.id"
            >
              <p class="u-font-16">
                <template v-if="defaultAddress.attributes.libelle">
                  <strong>{{ defaultAddress.attributes.libelle }}</strong>
                  <br />
                </template>
                {{ defaultAddress.attributes.prenom }}
                {{ defaultAddress.attributes.nom }}<br />
                {{ defaultAddress.attributes.adresse }}<br />
                <template v-if="defaultAddress.attributes.complement_adresse">
                  {{ defaultAddress.attributes.complement_adresse }}<br />
                </template>
                {{ defaultAddress.attributes.code_postal }}
                {{ defaultAddress.attributes.nom_commune }}
              </p>
              <template #action>
                <ButtonIcon
                  icon-name="pen"
                  icon-color="grey-9"
                  :aria-label="
                    `Modifier l'adresse : ${defaultAddress.attributes.libelle}`
                  "
                  @click="editAddresse(defaultAddress.id)"
                />
              </template>
            </FormRadio>
          </FormFieldset>

          <FormFieldset class="c-shipping-method-mobile-lad__fieldset">
            <FormLegend class="u-mb-sm">
              <template v-if="defaultAddress">
                Vos autres adresses
              </template>
              <template v-else>
                Vos adresses de livraison
              </template>
            </FormLegend>

            <FormRadio
              v-for="address in otherAddresses"
              :key="address.id"
              v-model="selectedAdressId"
              name="address"
              block
              class="u-mb-md"
              :value="address.id"
            >
              <p class="u-font-16">
                <template v-if="address.attributes.libelle">
                  <strong>{{ address.attributes.libelle }}</strong> <br />
                </template>
                {{ address.attributes.prenom }} {{ address.attributes.nom
                }}<br />
                {{ address.attributes.adresse }}<br />
                <template v-if="address.attributes.complement_adresse">
                  {{ address.attributes.complement_adresse }}<br />
                </template>
                {{ address.attributes.code_postal }}
                {{ address.attributes.nom_commune }}
              </p>
              <template #action>
                <ButtonIcon
                  icon-name="pen"
                  icon-color="grey-9"
                  icon-color-hover="primary-light"
                  :aria-label="
                    `Modifier l'adresse : ${address.attributes.libelle}`
                  "
                  @click="editAddresse(address.id)"
                />
              </template>
            </FormRadio>

            <div
              v-for="address in unavalaibleAddresses"
              :key="address.id"
            >
              <FormRadio
                name="address"
                block
                disabled
              >
                <p class="u-font-16">
                  <template v-if="address.attributes.libelle">
                    <strong>{{ address.attributes.libelle }}</strong> <br />
                  </template>
                  {{ address.attributes.prenom }} {{ address.attributes.nom
                  }}<br />
                  {{ address.attributes.adresse }}<br />
                  <template v-if="address.attributes.complement_adresse">
                    {{ address.attributes.complement_adresse }}<br />
                  </template>
                  {{ address.attributes.code_postal }}
                  {{ address.attributes.nom_commune }}
                </p>
                <template #action>
                  <ButtonIcon
                    icon-name="pen"
                    icon-color="grey-9"
                    icon-color-hover="primary-light"
                    :aria-label="
                      `Modifier l'adresse : ${address.attributes.libelle}`
                    "
                    @click="editAddresse(address.id)"
                  />
                </template>
              </FormRadio>

              <p class="u-font-16 u-color-grey-2 u-mt-xxs  u-mb-md">
                Cette adresse ne peut pas être livrée par le magasin Cora
                {{ magasinName }}.
              </p>
            </div>
            <Button
              v-if="canAdd"
              outline
              radius="md"
              size="md"
              class="u-block u-mr-lg"
              @click="addAddresse()"
            >
              <u class="u-color-text-light">
                Ajouter une adresse de livraison
              </u>
            </Button>
          </FormFieldset>
        </form>

        <!-- <p class="u-font-14 u-color-grey-2 u-mt-md u-mb-lg">
          En cas d'absence du client lors du créneau de livraison prévu :
          <br>
          - Dans le cas d’un nouveau rendez- vous, des frais de re-livraison ainsi que des frais de péremption correspondant au prix des denrées périssables (produits frais, fruits et légumes…) pourront éventuellement être facturés au client.
          <br>
          - Dans le cas d’une annulation de commande, des frais de péremption correspondant au prix des denrées périssables (produits frais, fruits et légumes…) seront facturés au client.
        </p> -->
      </div>

      <StickyFooter class="u-text-center">
        <Button
          variant="secondary"
          radius="full"
          size="md"
          :disabled="!selectedAdressId"
          @click="adressSelected()"
        >
          Je valide cette adresse
        </Button>
      </StickyFooter>
    </template>

    <template v-if="selectedAddress">
      <Card
        variant="bg"
        class="c-shipping-address-mobile"
      >
        <p class="c-shipping-address-mobile__title">
          <strong>Votre adresse de livraison</strong>
        </p>
        <div class="c-shipping-address-mobile__address">
          <p class="c-shipping-address-mobile__address-title">
            <template v-if="selectedAddress.attributes.libelle">
              <strong class="u-mr-sm">
                {{ selectedAddress.attributes.libelle }}
              </strong>
            </template>
            <Button
              class="c-shipping-address-mobile__button"
              variant="link"
              @click="resetAdress()"
            >
              Changer
            </Button>
          </p>
          <p class="c-shipping-address__address-val">
            {{ selectedAddress.attributes.prenom }}
            {{ selectedAddress.attributes.nom }}<br />
            {{ selectedAddress.attributes.adresse }}<br />
            <template v-if="selectedAddress.attributes.complement_adresse">
              {{ selectedAddress.attributes.complement_adresse }}<br />
            </template>
            {{ selectedAddress.attributes.code_postal }}
            {{ selectedAddress.attributes.nom_commune }}
          </p>
          <div>
            <Button
              class="c-shipping-address-mobile__button u-mt-xs"
              variant="link"
              @click="$refs.popinAddressDetail.show()"
            >
              Voir les indications pour le livreur
            </Button>
          </div>
        </div>
        <Popin
          ref="popinAddressDetail"
          slide-up
          aria-label="Votre adresse de livraison"
        >
          <p class="u-font-secondary u-color-primary u-font-24 u-font-700 u-mb-xs">
            Votre adresse de livraison
          </p>
          <p class="u-mb-sm">
            <template v-if="selectedAddress.attributes.libelle">
              <strong class="u-mb-xxs u-color-grey-1">{{
                selectedAddress.attributes.libelle
              }}</strong>
              <br />
            </template>
            {{ selectedAddress.attributes.prenom }}
            {{ selectedAddress.attributes.nom }}<br />
            <template v-if="selectedAddress.attributes.complement_adresse">
              {{ selectedAddress.attributes.complement_adresse }}<br />
            </template>
            {{ selectedAddress.attributes.adresse }}<br />
            {{ selectedAddress.attributes.code_postal }}
            {{ selectedAddress.attributes.nom_commune }}
          </p>
          <Divider dotted />
          <p class="u-font-secondary u-color-primary u-font-24 u-font-700 u-mt-md u-mb-xs">
            Indications Livreur
          </p>
          <AdresseLadRecap :adresse-lad="selectedAddress" />
          <ButtonGroup class=" u-mt-lg u-mb-lg">
            <Button
              link
              @click="editAddresse(selectedAddress.id)"
            >
              Éditer cette adresse
            </Button>
            <Button
              link
              @click="resetAdress()"
            >
              Changer d'adresse
            </Button>
          </ButtonGroup>
        </Popin>
      </Card>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-address-mobile.scss";
</style>
